import { queryOptions, useQuery } from '@tanstack/react-query';

import { ensureUniqueKeys } from 'src/utils/ensureUniqueKeys';
import { cloudEnterpriseApi } from '../endpoints';
import type {
  FleetDeviceWithMember,
  FleetUser,
} from '../endpoints/cloudEnterprise.types';
import { queryKeys } from './queryKeys';

export const queryFleetMembers = () =>
  queryOptions({
    queryKey: queryKeys.fleet.members,
    queryFn: () => cloudEnterpriseApi.getMembers(),
    select: (data) => ({
      ...data,
      users: data?.users?.sort((a, b) => {
        const aName = a.email ?? '';
        const bName = b.email ?? '';
        return aName.localeCompare(bName);
      }),
    }),
    staleTime: 60_000, // 1 minute
  });

export function useFleetMembers() {
  return useQuery(queryFleetMembers());
}

function pivotFromUsersToDevices(
  users: FleetUser[] = []
): FleetDeviceWithMember[] {
  const deviceList = users.flatMap(
    (user) =>
      user.devices?.map((device) => ({
        device,
        user,
      })) || []
  );
  return ensureUniqueKeys(deviceList, (item) => item.device.serialNumber);
}

export function useFleetDevices() {
  return useQuery({
    ...queryFleetMembers(),
    select: (data) => pivotFromUsersToDevices(data?.users),
  });
}
